import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, GraduationCap, ScrollText, BookOpen, User } from 'lucide-react';

const items = [
  { to: '/', label: 'ମୁଖ୍ୟ', labelEn: 'Home', icon: Home, end: true },
  { to: '/navodaya', label: 'ନବୋଦୟ', labelEn: 'Navodaya', icon: GraduationCap },
  { to: '/board', label: 'ବୋର୍ଡ', labelEn: 'Board', icon: ScrollText },
  { to: '/teacher', label: 'ଶିକ୍ଷକ', labelEn: 'Teacher', icon: BookOpen },
  { to: '/profile', label: 'ପ୍ରୋଫାଇଲ', labelEn: 'Profile', icon: User },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-gray-200 z-40 shadow-[0_-2px_10px_rgba(0,0,0,0.04)]">
      <div className="grid grid-cols-5">
        {items.map(({ to, label, labelEn, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${
                isActive ? 'text-emerald-600' : 'text-gray-500 hover:text-gray-700'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                <span className={`text-[10px] leading-tight text-center ${isActive ? 'font-semibold' : 'font-medium'}`}>{label}<br/><span className="text-[9px] opacity-70">{labelEn}</span></span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
